import { render, staticRenderFns } from "./CheckboxFacet.vue?vue&type=template&id=6d2a3fa5&scoped=true&"
import script from "./CheckboxFacet.vue?vue&type=script&lang=js&"
export * from "./CheckboxFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a3fa5",
  null
  
)

export default component.exports